/**
 * Input Schema of TypeSms
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {TypeSms} from '@/model/resource/TypeSms'

/* TODO: review generated schema */
export class InputTypeSmsSchema extends Schema {
  readonly name = 'InputTypeSms'

  readonly fieldSet: FieldSet<TypeSms> = {
    ativo: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
    nome: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 45,
        label: this.translateFrom(schema.fieldName),
      },
    }),
  }
}
